import join from '../images/join.jpg'
import '../components/css components/logistics.css';
import mediacover from "../images/cover-all.jpg";
import circle from "../images/media-modified.png";
function Media(){
    return(
        <div className='logistics' id='media'>
                    <div className='stick-them'>
                        <img src={mediacover} alt='logistics' className='cover-all'/>
                        <img src={circle} alt='logistics' className='circle-c' />
                    </div>  
                    <h2>Media Circle</h2>
                    <p className='quote'>"Capturing moments, telling stories, and spreading inspiration."</p>
                    <p className='paragraph'>The Media Circle holds a significant responsibility in the team by overseeing the creation of essential designs for advertisements. Their diverse tasks encompass various aspects of multimedia and branding. 
                    <ul>
                        <li>They collaborate with other circles to implement designs for electronic advertisements, ensuring a cohesive and visually appealing approach to promotions.</li>
                        <li> Designing all elements associated with promotional campaigns, guaranteeing a consistent and compelling visual representation of the team.</li>
                        <li> Adding an engaging multimedia dimension to the team's outreach efforts.</li>
                    </ul> 
                    Media Circle is divided into three sub-circles:
                    <ul>
                        <li>Content Creation: Focuses on content creation and management of social media pages.</li>
                        <li>Graphic Design: Responsible for creating visually appealing designs.</li>
                        <li>Video Editing and Motion Graphics: Handles video editing and motion graphics for content.</li>
                    </ul>
Furthermore, this circle plays a pivotal role in crafting and maintaining the team's visual identity, which is crucial for brand recognition. Lastly, they contribute to documenting the team's journey by capturing photos and videos of events, preserving memorable moments and achievements. In essence, the Media Circle is at the forefront of creating captivating visuals and multimedia content to promote and celebrate the team's endeavors.</p>
        </div>
    );
}

export default Media;